 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientAddress',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmation(response)
	{
		if (response.data.response_code === "related_household") {
			householdPropagateConfirm(form.name);

		// this means a confirm dialog needs to be thrown due to a duplicate household address
		} else if (response.data.response_code === "duplicate") {
			duplicateConfirm(form.name);

		// this means a confirm dialog needs to be thrown due to a connection error with Satori
		} else if (response.data.response_code === "connection_error") {
			Adzuki.AddressVerification.confirmRejected(response, form.name);

		// this is a Satori rejected address with no suggested alternative. User still should be able to force it through
		} else if (response.data.response_code > 100) {
			Adzuki.AddressVerification.confirmRejected(response, form.name);

		// a Satori alternate address suggested.  Need for user to confirm what to do with it
		} else {
			Adzuki.AddressVerification.confirmWithSuggestion(response, form.name);
		}
	};

	function duplicateConfirm(form_name)
	{
		var $jForm;

		Adzuki.CustomConfirm({
			body   : 'This address already exists for this client in your database. We do not recommend you create duplicate records. Do you wish to proceed with saving this address anyway?',
			confirm: function yes() {
				$jForm = $('form[name="' + form_name + '"]');

				// set hidden input indicating that the user wants to ignore the dupe address, so we do not throw a confirm again
				$jForm.find('.ignore_dupe').val(1);
				$jForm.submit();
			}
		});
	}

	function householdPropagateConfirm(form_name)
	{
		var $jForm = $('form[name="' + form_name + '"]');
		$jForm.find('.household_checked').val(1);

		Adzuki.CustomConfirm({
			body   : 'This address is related to a household. Do you wish to propagate address changes to the related household and other related client addresses?',
			confirm: function yes() {
				// set hidden input indicating that the user wants to propagate changes to household
				$jForm.find('.propagate_to_household').val(1);
				$jForm.submit();
			},
			cancel: function no() {
				$jForm.submit();
			}
		});
	}

}(jQuery, window.Adzuki || {}));
